import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-quill/dist/quill.snow.css'
import { Redirect } from 'react-router-dom';
import { Tooltip } from 'bootstrap';

import { getTokenInfo } from '../../UseToken';
import { api_crud_base, api_crud_route, api_list_route, data_interface, endpoints } from './Config';
import UseSidebar from '../../UseSidebar';
import 'react-phone-number-input/style.css'
import Hosts, { companycode } from '../../Hosts';

import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    translate,
    check_interface,

} from '../../Utils';

import Swal from 'sweetalert2'
import { language } from './Language';
import { color } from "../WEBContent/Color";
import { set } from 'core-js/core/dict';
import { getBlockInputType } from './Regist';

export default function View(props) {

    const dados = useRef(null);
    const [, set_dados] = useState(null);
    const [isRedirect, setRedirect] = useState(false);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');

    const [is_edit, set_is_edit] = useState(false)
    const [, set_image_base64] = useState([])
    const [show_delete_button, set_show_delete_button] = useState(false)

    const [refresh, setRefresh] = useState(0);
    const event_type = useRef(null);
    const entidades = useRef(null);

    const [files_image, set_files_image] = useState([])
    const [img_loader, set_img_loader] = useState([])

    const [name, setName] = useState(null)
    const [profile, setProfile] = useState(null)
    const [userID, setUserId] = useState(null)

    //Sondagens
    const [options, setOptions] = useState([]);
    const [newOption, setNewOption] = useState("");
    const [votes, setVotes] = useState({});
    const [userVotes, setUserVotes] = useState({});

    const [formResponses, setFormResponses] = useState({});
    const [viewingRespondentId, setViewingRespondentId] = useState(null);
    const [data, setData] = useState([]);
    const permissions = useRef(null);
    const { pathname } = useLocation()
    const [document_state_list, set_document_state_list] = useState([])

    const get_info = async () => {
        //await reqGET(api_list_route(getTokenInfo().companycode))
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }

    function apagar() {
        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: dados.current.id })
                        .then(() => {
                            props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
            .catch((erro) => {
                console.log(erro)
            })

    };

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    const savePoll = async () => {
        try {
            let res;

            if (dados.current?.id) {
                res = await reqPUT(`${api_crud_route}`, dados.current);
                return res?.data?.id || res?.data?._id || dados.current.id;

            } else {
                res = await reqPOST(`${api_crud_route}`, dados.current);
                return res?.data?.id || res?.data?._id;
            }

        } catch (err) {
            console.error("Error saving evento:", err);
        }
    };

    // ➡️ Adicionar opção
    const handle_add_option = async () => {
        if (newOption.trim() === "") return;

        const result = await Swal.fire({
            title: language[lang].adicionar_opcao,
            text: `${language[lang].confirmar_opcao} "${newOption}"?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: language[lang].insert_confirm,
            cancelButtonText: language[lang].insert_cancel,
        });

        if (!result.isConfirmed) return;

        const id = Date.now().toString();
        const newOpt = { id, text: newOption };

        const updatedOptions = [...options, newOpt];

        setOptions(updatedOptions);
        setNewOption("");

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options: updatedOptions,
            votes,
        };

        if (parseInt(dados.current.info.votacao) === 1) {
            Object.keys(votes).forEach((key) => {
                if (!updatedOptions.find((o) => o.id === key)) {
                    delete votes[key];
                }
            });
        }

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire(language[lang].adicionada, language[lang].adicionada_placeholder, "success");
    };

    const handle_remove_option = async (id) => {
        const optionToRemove = options.find((o) => o.id === id);
        if (!optionToRemove) return;

        const result = await Swal.fire({
            title: language[lang].remover_opcao,
            text: `${language[lang].remover_opcao_placeholder} "${optionToRemove.text}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel,
        });

        if (!result.isConfirmed) return;

        const updatedOptions = options.filter((o) => o.id !== id);

        const updatedVotes = { ...votes };
        delete updatedVotes[id];

        setOptions(updatedOptions);
        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options: updatedOptions,
            votes: updatedVotes,
        };

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire(language[lang].removida, language[lang].removida_placeholder, "success");
    };

    // ➡️ Votar
    const handle_vote = async (id) => {
        let updatedVotes = { ...votes };
        let updatedVoters = new Set(dados.current.info.poll?.voters || []);

        if (dados.current.info.votacao_oculta === "2") {
            if (updatedVoters.has(userID)) {
                await Swal.fire(language.erro, language.insert_error, "error");
                return;
            }

            const result = await Swal.fire({
                title: language[lang].confirmar_voto,
                text: language[lang].confirmar_voto_placeholder,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            });

            if (!result.isConfirmed) return;

            if (parseInt(dados.current.info.votacao) === 1) {
                Object.keys(updatedVotes).forEach((key) => {
                    updatedVotes[key] = 0;
                });
            }

            updatedVotes[id] = (updatedVotes[id] || 0) + 1;
            updatedVoters.add(userID);
        }

        else {
            const alreadyVoted = updatedVotes[id]?.some((u) => u.userID === userID);

            const result = await Swal.fire({
                title: alreadyVoted ? language[lang].remover_voto : language[lang].confirmar_voto,
                text: alreadyVoted
                    ? language[lang].remover_voto_placeholder
                    : language[lang].confirmar_voto_placeholder,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            });

            if (!result.isConfirmed) return;

            if (parseInt(dados.current.info.votacao) === 1) {

                Object.keys(updatedVotes).forEach((key) => {
                    updatedVotes[key] = (updatedVotes[key] || []).filter(
                        (u) => u.userID !== userID
                    );
                });
            }

            if (alreadyVoted) {
                updatedVotes[id] = updatedVotes[id].filter((u) => u.userID !== userID);

            } else {
                updatedVotes[id] = [
                    ...(updatedVotes[id] || []),
                    { userID, name, profile },
                ];
            }
        }

        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options,
            votes: updatedVotes,
            voters: Array.from(updatedVoters),
        };

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire(language[lang].sucesso, language[lang].escolha, "success");
    };

    // ➡️ Remover voto
    const handle_unvote = async (id) => {
        let updatedVotes = { ...votes };
        let updatedVoters = new Set(dados.current.info.poll?.voters || []);

        if (dados.current.info.votacao_oculta === "2") {
            if (!updatedVoters.has(userID)) {
                Swal.fire("Erro", "Ainda não votaste, não há nada para remover.", "error");
                return;
            }
        }

        const result = await Swal.fire({
            title: "Remover voto?",
            text: "Queres mesmo remover o teu voto?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
        });

        if (!result.isConfirmed) return;

        if (dados.current.info.votacao_oculta === "2") {
            // Apenas decrementa e remove do array de votantes
            if (updatedVotes[id] > 0) {
                updatedVotes[id] = updatedVotes[id] - 1;
            }
            updatedVoters.delete(userID);
        } else {
            // Votação não oculta → pode remover o voto sempre que quiser
            updatedVotes[id] = updatedVotes[id]?.filter((u) => u.userID !== userID) || [];
        }

        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options,
            votes: updatedVotes,
            voters: Array.from(updatedVoters),
        };

        set_dados({ ...dados.current.info });
        await savePoll();

        Swal.fire("Voto removido!", "O teu voto foi retirado.", "success");
    };

    // ➡️ Cálculo total de votos
    const totalVotes = Object.values(votes).reduce((acc, val) => {
        if (Array.isArray(val)) return acc + val.length;
        if (typeof val === "number") return acc + val;
        return acc;
    }, 0);

    useEffect(() => {
        clean_data();
        get_type_event();
        fetch_entidades();
        set_lang(localStorage.getItem('lang'));

        // Lê o userID diretamente do token — não depende do state
        let currentUserId = null;
        const storedData = localStorage.getItem('token');
        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info && !data.user_info.user_info) {
                setProfile(data.user_info.profile);
                setName(data.user_info.name);
                setUserId(data.user_info.id);
                currentUserId = data.user_info.id;
            }
        }

        try {
            const test = props.location.state.operation;

            if (test === 'view') {
                set_is_edit(true);
                set_show_delete_button(true);
                set_image_base64([]);
                set_dados(dados.current.id = props.location.state.item.id);

                fetch_id_info(props.location.state.item.id).then(() => {
                    const respondentId = props.location.state.item?.respondent_userId;

                    if (respondentId) {
                        // Modo leitura — respostas de outra pessoa
                        const saved = dados.current?.info?.forms_responses?.[respondentId];
                        if (saved) {
                            // Remove o _saved_at das respostas para não confundir com campos reais
                            const { _saved_at, ...responses } = saved;
                            setFormResponses(responses);
                        }
                        setViewingRespondentId(String(respondentId));
                    } else {
                        // Utilizador normal — as suas próprias respostas
                        const saved = dados.current?.info?.forms_responses?.[currentUserId];
                        if (saved) {
                            const { _saved_at, ...responses } = saved;
                            setFormResponses(responses);
                        }
                    }
                    setLoading(false);
                });
                return;
            } else {
                set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1);
                setLoading(false);
            }
        } catch {
            clean_data();
            setLoading(false);
            setRedirect(false);
            return;
        }

        return () => { clean_data(); };
    }, [props]);

    const fetch_id_info = async (id_serch) => {

        return await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
            .then(res => {

                set_dados(dados.current = res.data[0]);

            })
            .catch(error => console.log(error))
    }

    const clean_data = () => {
        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
        set_dados(dados.current.info.companycode = getTokenInfo().companycode)
    }

    useEffect(() => {


        console.log('props.location.state', props.location.state)


        clean_data();

        get_type_event()
        fetch_entidades()

        set_lang(localStorage.getItem('lang'))

        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);

        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {
                if (data.user_info.user_info) {

                } else {

                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                }

            } else {
                console.log('User info nÃ£o encontrado no localStorage');
            }

        } else {
            console.log('Dados nÃ£o encontrados no localStorage');
        }

        try {
            let test = props.location.state.operation;

            if (test === 'view') {
                //set_disabled(true)

                set_is_edit(true)
                set_show_delete_button(true)

                set_image_base64([])
                set_dados(dados.current.id = props.location.state.item.id)

                fetch_id_info(props.location.state.item.id).then(() => {
                    const respondentId = props.location.state.item?.respondent_userId;

                    if (respondentId) {
                        // Mostra as respostas do utilizador específico (modo leitura)
                        const saved = dados.current?.info?.forms_responses?.[respondentId];
                        if (saved) setFormResponses(saved);
                        setViewingRespondentId(respondentId);
                    } else {
                        // Utilizador normal — carrega as suas próprias respostas
                        const saved = dados.current?.info?.forms_responses?.[userID];
                        if (saved) setFormResponses(saved);
                    }
                    setLoading(false);
                });
                return
            }
            else {
                set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
                setLoading(false)
            }

        } catch {
            clean_data()

            setLoading(false);

            setRedirect(false);
            return
        }

        return () => {
            clean_data()

        }

    }, [props])

    const get_type_event = async () => {
        let res_event = await reqGET(`${api_crud_base}/evento/type/${getTokenInfo().companycode}/event_type`);
        let result = [];

        if (res_event.data !== undefined) {
            result = res_event.data.filter(el => el.info.avaiable === true);
        }

        set_dados(event_type.current = result);
    };

    const fetch_entidades = async () => {
        try {
            let res_entidade = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
            let result = [];

            if (res_entidade.data !== undefined) {
                result = res_entidade.data.filter(el => el.entity_type === "1");
            }

            set_dados(entidades.current = result);

        } catch (error) {
            console.error("Erro ao buscar as Entidades:", error);
            return [];
        }
    };

    const handle_form_response = (blockUid, questionUid, value) => {
        const updated = {
            ...formResponses,
            [blockUid]: {
                ...(formResponses[blockUid] || {}),
                [questionUid]: value,
            }
        };
        setFormResponses(updated);

        if (!dados.current.info.forms_responses) {
            dados.current.info.forms_responses = {};
        }
        dados.current.info.forms_responses[userID] = updated;
    };

    const handlePrint = () => {
        const respondentName = (entidades.current || []).find(e => String(e.id) === String(viewingRespondentId))?.name || viewingRespondentId;
        const title = lang === 'en'
            ? dados.current.info?.title?.[0]?.en || ''
            : dados.current.info?.title?.[0]?.pt || '';

        const savedAt = dados.current?.info?.forms_responses?.[viewingRespondentId]?._saved_at;

        const blocksHtml = (dados.current.info?.forms_type || []).map(block => {
            const questionsHtml = (block.questions || []).map(question => {
                const { inputType } = getBlockInputType(block.type_name);
                const value = formResponses[block.uid]?.[question.uid];

                let answerHtml = '';
                if (!value || (Array.isArray(value) && value.length === 0)) {
                    answerHtml = `<span style="color:#adb5bd;font-style:italic;">Sem resposta</span>`;
                } else if (inputType === 'slider') {
                    answerHtml = `<span>${value}%</span>`;
                } else if (Array.isArray(value)) {
                    answerHtml = value.map(v => `<span style="display:inline-block;background:#e8f4fd;border:1px solid #0095e8;padding:2px 8px;margin:2px;border-radius:2px;">${v}</span>`).join('');
                } else {
                    answerHtml = `<span>${value}</span>`;
                }

                return `
                <div style="margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid #f0f0f0;">
                    ${question.label ? `<p style="font-weight:600;font-size:13px;margin-bottom:6px;">${question.label}</p>` : ''}
                    <div style="font-size:13px;">${answerHtml}</div>
                </div>
            `;
            }).join('');

            return `
            <div style="margin-bottom:24px;">
                <h6 style="font-size:14px;font-weight:700;border-left:3px solid #0095e8;padding-left:10px;margin-bottom:12px;">
                    ${block.title || block.type_name}
                </h6>
                ${questionsHtml}
            </div>
        `;
        }).join('');

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>${title} — ${respondentName}</title>
            <style>
                body { font-family: Arial, sans-serif; padding: 40px; color: #212529; }
                h1 { font-size: 20px; margin-bottom: 4px; }
                .meta { font-size: 12px; color: #6c757d; margin-bottom: 32px; }
                @media print { body { padding: 20px; } }
            </style>
        </head>
        <body>
            <h1>${title}</h1>
            <div class="meta">
                Respostas de <strong>${respondentName}</strong>
                ${savedAt ? ` — guardado em ${new Date(savedAt).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}` : ''}
            </div>
            ${blocksHtml}
        </body>
        </html>
    `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    return isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language[lang].loading}</h2>
                <p>{language[lang].loading}</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>
            </div>
        </main>
        :
        isRedirect
            ?
            <Redirect to={endpoints.list} replace />
            :
            <main>
                <div className="dash-cards-2 header">
                    <div className="row mt-4 mb-3">
                        <div className="row justify-content-center mt-4 mb-5">
                            <div className="col-md-10 col-lg-8">
                                <div className="card border-0 shadow" style={{ borderRadius: 0, borderTop: '4px solid #0095e8' }}>

                                    {/* Cabeçalho */}
                                    <div className="card-body px-5 pt-5 pb-4">
                                        <h3 className="fw-bold mb-3" style={{ fontSize: 22, color: '#1a1a2e' }}>
                                            {lang === "en"
                                                ? dados.current.info?.title?.[0]?.en || ""
                                                : dados.current.info?.title?.[0]?.pt || ""}
                                        </h3>
                                        {(lang === "en" ? dados.current.info?.description?.[0]?.en : dados.current.info?.description?.[0]?.pt) && (
                                            <p className="text-muted" style={{ fontSize: 14, lineHeight: 1.8 }}>
                                                {lang === "en"
                                                    ? dados.current.info?.description?.[0]?.en
                                                    : dados.current.info?.description?.[0]?.pt}
                                            </p>
                                        )}
                                    </div>

                                    {/* Corpo do formulário */}
                                    {(dados.current.info?.forms_type || []).length > 0 && (
                                        <div className="px-5 pt-5 py-4">
                                            {(dados.current.info.forms_type || []).map((block, bIndex) => (
                                                <div key={block.uid} className="mb-5">

                                                    {/* Cabeçalho do bloco */}
                                                    {(block.title || block.type_name) && (
                                                        <div className="d-flex align-items-center gap-2 mb-4"
                                                            style={{ borderLeft: '3px solid #0095e8', paddingLeft: 12 }}>
                                                            <div>
                                                                <h6 className="fw-bold mb-0" style={{ fontSize: 14, color: '#1a1a2e' }}>
                                                                    {block.title || block.type_name}
                                                                </h6>
                                                                {/* 
                                                                {block.title && (
                                                                    <span style={{ fontSize: 11, color: '#adb5bd', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                                        {block.type_name}
                                                                    </span>
                                                                )}
                                                                */}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(block.questions || []).map((question, qIndex) => {
                                                        const { inputType } = getBlockInputType(block.type_name);
                                                        const value = formResponses[block.uid]?.[question.uid];

                                                        return (
                                                            <div key={question.uid}
                                                                className="mb-4 pb-4"
                                                                style={{ borderBottom: qIndex < block.questions.length - 1 ? '1px solid #f0f0f0' : 'none' }}>

                                                                {question.label && (
                                                                    <p className="mb-3" style={{ fontSize: 13, fontWeight: 600, color: '#343a40' }}>
                                                                        {question.label}
                                                                    </p>
                                                                )}

                                                                {inputType === 'textarea' && (
                                                                    <textarea
                                                                        className="form-control rounded-0"
                                                                        rows={3}
                                                                        style={{ fontSize: 13, borderColor: '#dee2e6', resize: 'vertical' }}
                                                                        value={formResponses[block.uid]?.[question.uid] || ''}
                                                                        onChange={(e) => !viewingRespondentId && handle_form_response(block.uid, question.uid, e.target.value)}
                                                                        placeholder={question.label || ''}
                                                                        disabled={!!viewingRespondentId}
                                                                    />
                                                                )}

                                                                {['password', 'email', 'tel', 'url'].includes(inputType) && (
                                                                    <input type={inputType} className="form-control rounded-0"
                                                                        style={{ maxWidth: 320, fontSize: 13 }}
                                                                        value={value || ''}
                                                                        disabled={!!viewingRespondentId}
                                                                        onChange={(e) => !viewingRespondentId && handle_form_response(block.uid, question.uid, e.target.value)} />
                                                                )}

                                                                {inputType === 'number' && (
                                                                    <input type="number" className="form-control rounded-0"
                                                                        style={{ maxWidth: 150, fontSize: 13 }}
                                                                        value={value || ''}
                                                                        disabled={!!viewingRespondentId}
                                                                        onChange={(e) => !viewingRespondentId && handle_form_response(block.uid, question.uid, e.target.value)} />
                                                                )}

                                                                {inputType === 'date' && (
                                                                    <input type="date" className="form-control rounded-0"
                                                                        style={{ maxWidth: 200, fontSize: 13 }}
                                                                        value={value || ''}
                                                                        disabled={!!viewingRespondentId}
                                                                        onChange={(e) => !viewingRespondentId && handle_form_response(block.uid, question.uid, e.target.value)} />
                                                                )}

                                                                {inputType === 'slider' && (
                                                                    <div style={{ maxWidth: 350 }}>
                                                                        <input type="range" className="form-range" min={0} max={100} step={1}
                                                                            value={value ?? 50}
                                                                            disabled={!!viewingRespondentId}
                                                                            onChange={(e) => !viewingRespondentId && handle_form_response(block.uid, question.uid, e.target.value)} />
                                                                        <div className="d-flex justify-content-between" style={{ fontSize: 11, color: '#adb5bd' }}>
                                                                            <span>0</span>
                                                                            <span className="fw-bold" style={{ color: '#0095e8' }}>{value ?? 50}</span>
                                                                            <span>100</span>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {inputType === 'select' && (
                                                                    <select className="form-select rounded-0"
                                                                        style={{ maxWidth: 320, fontSize: 13 }}
                                                                        value={value || ''}
                                                                        disabled={!!viewingRespondentId}
                                                                        onChange={(e) => !viewingRespondentId && handle_form_response(block.uid, question.uid, e.target.value)}>
                                                                        <option value="">{language[lang].select || 'Selecionar...'}</option>
                                                                        {(question.options || []).filter(Boolean).map((opt, i) => (
                                                                            <option key={i} value={opt}>{opt}</option>
                                                                        ))}
                                                                    </select>
                                                                )}

                                                                {/* Single-Select — radio horizontal, escolha única */}
                                                                {inputType === 'single' && (
                                                                    <div className="d-flex flex-wrap gap-2 ms-1">
                                                                        {(question.options || []).filter(Boolean).map((opt, oIndex) => {
                                                                            const isChecked = value === opt;
                                                                            return (
                                                                                <label key={oIndex}
                                                                                    className="d-flex align-items-center gap-2 px-3 py-2"
                                                                                    style={{
                                                                                        fontSize: 13,
                                                                                        cursor: viewingRespondentId ? 'default' : 'pointer',
                                                                                        border: `1px solid ${isChecked ? '#0095e8' : '#dee2e6'}`,
                                                                                        backgroundColor: isChecked ? '#e8f4fd' : '#fff',
                                                                                        userSelect: 'none'
                                                                                    }}>
                                                                                    <input type="radio"
                                                                                        name={`${block.uid}_${question.uid}`}
                                                                                        value={opt}
                                                                                        checked={isChecked}
                                                                                        disabled={!!viewingRespondentId}
                                                                                        onChange={() => !viewingRespondentId && handle_form_response(block.uid, question.uid, opt)}
                                                                                        style={{ cursor: viewingRespondentId ? 'default' : 'pointer', accentColor: '#0095e8' }} />
                                                                                    {opt}
                                                                                </label>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}

                                                                {/* Radio / Lista — vertical, escolha única */}
                                                                {inputType === 'radio' && (
                                                                    <div className="d-flex flex-column gap-2 ms-1">
                                                                        {(question.options || []).filter(Boolean).map((opt, oIndex) => {
                                                                            const isChecked = value === opt;
                                                                            return (
                                                                                <label key={oIndex}
                                                                                    className="d-flex align-items-center gap-2 px-3 py-2"
                                                                                    style={{
                                                                                        fontSize: 13,
                                                                                        cursor: viewingRespondentId ? 'default' : 'pointer',
                                                                                        border: `1px solid ${isChecked ? '#0095e8' : '#dee2e6'}`,
                                                                                        backgroundColor: isChecked ? '#e8f4fd' : '#fff',
                                                                                        userSelect: 'none'
                                                                                    }}>
                                                                                    <input type="radio"
                                                                                        name={`${block.uid}_${question.uid}`}
                                                                                        value={opt}
                                                                                        checked={isChecked}
                                                                                        disabled={!!viewingRespondentId}
                                                                                        onChange={() => !viewingRespondentId && handle_form_response(block.uid, question.uid, opt)}
                                                                                        style={{ cursor: viewingRespondentId ? 'default' : 'pointer', accentColor: '#0095e8' }} />
                                                                                    {opt}
                                                                                </label>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}

                                                                {/* Multi-Select — checkboxes, múltipla escolha */}
                                                                {inputType === 'multi' && (
                                                                    <div className="d-flex flex-column gap-2 ms-1">
                                                                        {(question.options || []).filter(Boolean).map((opt, oIndex) => {
                                                                            const selected = Array.isArray(value) ? value : [];
                                                                            const isChecked = selected.includes(opt);
                                                                            return (
                                                                                <label key={oIndex}
                                                                                    className="d-flex align-items-center gap-2 px-3 py-2"
                                                                                    style={{
                                                                                        fontSize: 13,
                                                                                        cursor: viewingRespondentId ? 'default' : 'pointer',
                                                                                        border: `1px solid ${isChecked ? '#0095e8' : '#dee2e6'}`,
                                                                                        backgroundColor: isChecked ? '#e8f4fd' : '#fff',
                                                                                        userSelect: 'none'
                                                                                    }}>
                                                                                    <input type="checkbox"
                                                                                        checked={isChecked}
                                                                                        disabled={!!viewingRespondentId}
                                                                                        onChange={() => {
                                                                                            if (viewingRespondentId) return;
                                                                                            const updated = isChecked
                                                                                                ? selected.filter(v => v !== opt)
                                                                                                : [...selected, opt];
                                                                                            handle_form_response(block.uid, question.uid, updated);
                                                                                        }}
                                                                                        style={{ cursor: viewingRespondentId ? 'default' : 'pointer', accentColor: '#0095e8' }} />
                                                                                    {opt}
                                                                                </label>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}

                                            <div className="d-flex align-items-center justify-content-between border-top pt-4 mt-2">
                                                {viewingRespondentId ? (
                                                    <span style={{ fontSize: 13, color: '#6c757d' }}>
                                                        <i className="bi bi-eye me-2"></i>
                                                        {language[lang].viewing_responses_of || 'A ver respostas de '}
                                                        <strong>
                                                            {(entidades.current || []).find(e => e.id === viewingRespondentId)?.name || viewingRespondentId}
                                                        </strong>
                                                        {dados.current?.info?.forms_responses?.[viewingRespondentId]?._saved_at && (
                                                            <span className="ms-2" style={{ fontSize: 11, color: '#adb5bd' }}>
                                                                — {new Date(dados.current.info.forms_responses[viewingRespondentId]._saved_at).toLocaleString('pt-PT', {
                                                                    day: '2-digit', month: '2-digit', year: 'numeric',
                                                                    hour: '2-digit', minute: '2-digit'
                                                                })}
                                                            </span>
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span style={{ fontSize: 12, color: '#adb5bd' }}>
                                                        <i className="bi bi-info-circle me-1"></i>
                                                        {dados.current.info?.forms_responses?.[userID]?._saved_at ? (
                                                            <>
                                                                {language[lang].form_save_hint || 'Última resposta guardada em '}
                                                                <strong style={{ color: '#6c757d' }}>
                                                                    {new Date(dados.current.info.forms_responses[userID]._saved_at).toLocaleString('pt-PT', {
                                                                        day: '2-digit', month: '2-digit', year: 'numeric',
                                                                        hour: '2-digit', minute: '2-digit'
                                                                    })}
                                                                </strong>
                                                            </>
                                                        ) : (
                                                            language[lang].form_save_hint || 'As respostas são guardadas por utilizador.'
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">

                                {(dados.current.info?.createadBy?.some((entry) => entry.userId === userID) ||
                                    permissions.current !== null && permissions.current.create) && (
                                        <li className={"nav-item " + show_delete_button}>
                                            <button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
                                                <i className="bi bi-trash3 me-2"></i>
                                                <span>{language[lang].delete}</span>
                                            </button>
                                        </li>
                                    )}

                                {viewingRespondentId && (
                                    profile === 'Administrador' ||
                                    (dados.current?.info?.createadBy || []).some(e => e.userId === userID)
                                ) && (
                                        <li className="nav-item">
                                            <button type="button" className="nav-link" onClick={handlePrint}>
                                                <i className="bi bi-printer me-2"></i>
                                                <span>{language[lang].imprimir_relatorio || 'Imprimir'}</span>
                                            </button>
                                        </li>
                                    )}

                                {!viewingRespondentId && (
                                    <li className="nav-item">
                                        <button type="button" className="nav-link"
                                            onClick={async () => {
                                                const jaRespondeu = dados.current?.info?.forms_responses?.[userID] !== undefined;
                                                const savedAt = dados.current?.info?.forms_responses?.[userID]?._saved_at;
                                                const savedAtStr = savedAt
                                                    ? new Date(savedAt).toLocaleString('pt-PT', {
                                                        day: '2-digit', month: '2-digit', year: 'numeric',
                                                        hour: '2-digit', minute: '2-digit'
                                                    })
                                                    : null;

                                                const result = await Swal.fire({
                                                    title: jaRespondeu
                                                        ? language[lang].formulario_atualizar || 'Atualizar respostas'
                                                        : language[lang].formulario_guardar || 'Guardar respostas',
                                                    html: jaRespondeu && savedAtStr
                                                        ? `${language[lang].formulario_respondido_text || 'Já respondeste a este formulário em'} <strong>${savedAtStr}</strong>.<br/><br/>${language[lang].formulario_atualizar_hint || 'Queres substituir as tuas respostas anteriores?'}`
                                                        : language[lang].formulario_guardar_text || 'Queres guardar as tuas respostas?',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonColor: '#0095e8',
                                                    cancelButtonColor: '#6c757d',
                                                    confirmButtonText: language[lang].insert_confirm || 'Confirmar',
                                                    cancelButtonText: language[lang].insert_cancel || 'Cancelar',
                                                });

                                                if (!result.isConfirmed) return;

                                                if (!dados.current.info.forms_responses) dados.current.info.forms_responses = {};
                                                dados.current.info.forms_responses[userID] = {
                                                    ...formResponses,
                                                    _saved_at: new Date().toISOString()
                                                };
                                                set_dados({ ...dados.current });
                                                await savePoll();
                                                Swal.fire(
                                                    language[lang].sucesso || 'Guardado',
                                                    language[lang].guardado || 'As tuas respostas foram guardadas.',
                                                    'success'
                                                );
                                            }}>
                                            <i className="bi bi-floppy me-2"></i>
                                            <span>{language[lang].save || 'Guardar respostas'}</span>
                                        </button>
                                    </li>
                                )}

                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <i className="bi bi-arrow-left"></i>
                                        <span> {language[lang].back}</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </main>
}